import { render, staticRenderFns } from "./ModalGroups.vue?vue&type=template&id=a88714dc"
import script from "./ModalGroups.vue?vue&type=script&lang=js"
export * from "./ModalGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports